import { Injectable } from "@angular/core"
import { Observable } from "rxjs"
import { Currency } from "src/app/domain/models/currency"

@Injectable({providedIn: 'root'})
export abstract class CurrencyGateway {
  abstract getAll(): Observable<Currency[]>
}
